/* eslint-disable camelcase */

export const formFamily = Object.freeze({
  w: 'W',
  crs: 'CRS',
  fatcacrs: 'FATCA CRS',
});

function getFormFamily(formType) {
  formType = formType.toLowerCase();
  if (formType.startsWith('w')) {
    return formFamily.w;
  }

  if (formType.startsWith('crs')) {
    return formFamily.crs;
  }

  if (formType.startsWith('fatca_crs')) {
    return formFamily.fatcacrs;
  }

  return undefined;
}

function createFormType(formType, { hasStockMarket = false, isNoFormSupported = false }) {
  return Object.freeze({
    formType: formType.toLowerCase(),
    formFamily: getFormFamily(formType),
    hasStockMarket,
    isNoFormSupported,
  });
}

const w9_2018 = createFormType('w9_2018', { isNoFormSupported: true });
const w9_2024 = createFormType('w9_2024', { isNoFormSupported: true });

const w8ben = createFormType('w8ben', { isNoFormSupported: true });
const w8ben_2021 = createFormType('w8ben_2021', { isNoFormSupported: true });

const w8bene = createFormType('w8bene', { hasStockMarket: true });
const w8bene_2017 = createFormType('w8bene_2017', { hasStockMarket: true });
const w8bene_2021 = createFormType('w8bene_2021', { hasStockMarket: true, isNoFormSupported: true });

const w8imy = createFormType('w8imy', { hasStockMarket: true });
const w8imy_2017 = createFormType('w8imy_2017', { hasStockMarket: true });
const w8imy_2021 = createFormType('w8imy_2021', { hasStockMarket: true, isNoFormSupported: true });

const crsi = createFormType('crsi', { isNoFormSupported: true });
const crsi_2024 = createFormType('crsi_2024', { isNoFormSupported: true });
const crse = createFormType('crse', { hasStockMarket: true, isNoFormSupported: true });
const crscp = createFormType('crscp', { isNoFormSupported: true });
const ucrse_2019 = createFormType('ucrse_2019', { hasStockMarket: true });

const fatca_crse_2022 = createFormType('fatca_crse_2022', { hasStockMarket: true, isNoFormSupported: true });
const fatca_crse_2023 = createFormType('fatca_crse_2023', { hasStockMarket: true, isNoFormSupported: true });

const fatca_crsi_2023 = createFormType('fatca_crsi_2023', { isNoFormSupported: true });

const rc518 = createFormType('rc518', { isNoFormSupported: true });
const rc518_2024 = createFormType('rc518_2024', { isNoFormSupported: true });
const rc519 = createFormType('rc519', { isNoFormSupported: true });
const rc519_2024 = createFormType('rc519_2024', { isNoFormSupported: true });

export const formTypes = Object.freeze([
  w9_2018,
  w9_2024,
  w8ben,
  w8ben_2021,
  w8bene,
  w8bene_2017,
  w8bene_2021,
  w8imy,
  w8imy_2017,
  w8imy_2021,
  crsi,
  crsi_2024,
  crse,
  crscp,
  ucrse_2019,
  fatca_crse_2022,
  fatca_crse_2023,
  fatca_crsi_2023,
  rc518,
  rc518_2024,
  rc519,
  rc519_2024
]);

export function getFormType(formType) {
  return formTypes.find(ft => ft.formType === formType?.toLowerCase());
}
